import React from 'react';
import { Archive, MessageSquare } from 'lucide-react';
import type { EmptyStateProps } from '../types';

/**
 * Empty state component
 * Memoized component for displaying empty state UI
 */
export const EmptyState: React.FC<EmptyStateProps> = React.memo(
  ({ activeTab }) => (
    <div className="p-6 text-center">
      <div className="flex justify-center mb-3">
        {activeTab === 'archived' ? (
          <Archive className="w-12 h-12 text-muted-foreground" />
        ) : (
          <MessageSquare className="w-12 h-12 text-muted-foreground" />
        )}
      </div>
      <p className="text-sm font-medium text-foreground">
        {activeTab === 'archived' ? 'No archived chats' : 'No chats yet'}
      </p>
      <p className="text-xs text-muted-foreground mt-1">
        {activeTab === 'archived' 
          ? 'Archived chats will appear here'
          : 'Start a new conversation'}
      </p>
    </div>
  )
);

EmptyState.displayName = 'EmptyState';
